function chatHeaderProperty(chat, propertyByPeopleId = {}) {
  if (!chat || chat.groupId) return '';
  if (chat.personId == null || chat.personId === '') return '';
  if (chat.userId != null && chat.userId !== '') return '';
  const direct = String(chat.propertyAddress || '').trim();
  if (direct) return direct;
  const mapped = propertyByPeopleId[Number(chat.personId)];
  return mapped ? String(mapped).trim() : '';
}

function isSystemChatHead(chat) {
  if (!chat || (chat.groupId != null && chat.groupId !== '')) return false;
  return isZeroUserId(chat.userId);
}

function chatHeadFaceLabel(chat) {
  if (!chat) return '';
  if (chat.groupId != null && chat.groupId !== '') return chat.groupName || '';
  if (isSystemChatHead(chat)) return 'Sys';
  return chat.initials || '';
}

/** Source initials after a timestamp. The Sys channel is only system messages. */
function chatTimestampSourceLabel(chat, label) {
  if (isSystemChatHead(chat)) return '';
  return label || '';
}

function isZeroUserId(value) {
  return value != null && value !== '' && Number(value) === 0;
}

function chatHeaderNotifyOn(chat) {
  if (!isTenantChatHead(chat)) return false;
  return Number(chat.pixieNotifications) === 1;
}

function isSweepableInsideChat(chat) {
  if (!chat || isSystemChatHead(chat)) return false;
  if (chat.groupId != null && chat.groupId !== '') return false;
  return true;
}

function isTenantChatHead(chat) {
  if (!chat || isSystemChatHead(chat)) return false;
  if (chat.groupId != null && chat.groupId !== '') return false;
  return (
    chat.personId != null &&
    chat.personId !== '' &&
    (chat.userId == null || chat.userId === '')
  );
}

function chatHeadSection(chat) {
  if (isSystemChatHead(chat)) return 'staff';
  if (chat && chat.groupId != null && chat.groupId !== '') return 'groups';
  if (
    chat &&
    chat.personId != null &&
    chat.personId !== '' &&
    (chat.userId == null || chat.userId === '')
  ) {
    return 'tenants';
  }
  return 'staff';
}

function canAccessSystemChat(role) {
  if (role == null || role === '') return false;
  const n = Number(role);
  return Number.isFinite(n) && n < 3;
}

function visibleInsideChats(chats, role) {
  const list = chats || [];
  if (canAccessSystemChat(role)) return list;
  return list.filter((chat) => !isSystemChatHead(chat));
}

function groupChatHeads(chats) {
  const buckets = { tenants: [], staff: [], groups: [] };
  let systemIndex = -1;
  for (const chat of chats || []) {
    if (isSystemChatHead(chat)) {
      if (systemIndex === -1) {
        buckets.staff.push(chat);
        systemIndex = buckets.staff.length - 1;
      }
      continue;
    }
    buckets[chatHeadSection(chat)].push(chat);
  }
  return [
    { key: 'tenants', label: 'tenants', chats: buckets.tenants },
    { key: 'staff', label: 'staff', chats: buckets.staff },
    { key: 'groups', label: 'groups', chats: buckets.groups },
  ].filter((section) => section.chats.length);
}

module.exports = {
  chatHeaderProperty,
  chatHeaderNotifyOn,
  chatHeadSection,
  chatHeadFaceLabel,
  chatTimestampSourceLabel,
  isSystemChatHead,
  isSweepableInsideChat,
  isTenantChatHead,
  canAccessSystemChat,
  visibleInsideChats,
  groupChatHeads,
};
